/** システム告知情報 */
export function saveSystemAnnouncement(message) {
    return {
        type: "SAVE_SYSTEM_ANNOUNCEMENT",
        systemAnnouncement: message
    };
}
